<template>
  <RevCard class="px-56 py-32">
    <RevContentBlock
      :button-label="i18n(translations.createAddress)"
      :image-props
      :surtitle="i18n(translations.surtitle)"
      :title="i18n(translations.title)"
      @click="handleClick"
    >
      <span class="body-1">
        {{ i18n(translations.description) }}
      </span>
    </RevContentBlock>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevContentBlock } from '@ds/components/ContentBlock'

import translations from './EmptyState.translations'

const emit = defineEmits(['open-create-address-form-modal'])

const i18n = useI18n()

const imageProps = {
  alt: '',
  height: 257,
  src: '/img/empty.svg',
  width: 465,
}

function handleClick() {
  emit('open-create-address-form-modal')
}
</script>
